import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import { Construction, ArrowLeft } from 'lucide-react';

const featureDetails = {
  '/reports': {
    title: 'Reports',
    description: 'View portfolio-wide reports, maintenance trends, occupancy rates, and financial summaries across your properties.',
  },
  '/team': {
    title: 'Team Management',
    description: 'Manage your property management team, assign roles, and collaborate with colleagues.',
  },
  '/settings': {
    title: 'Settings',
    description: 'Configure your account preferences, notification settings, and organization details.',
  },
  '/help': {
    title: 'Help Center',
    description: 'Access guides, FAQs, and support resources to get the most out of Nivasapro.',
  },
  '/lease': {
    title: 'My Lease',
    description: 'View your lease agreement details, terms, and important dates.',
  },
  '/payments': {
    title: 'Payments',
    description: 'Make rent payments, view payment history, and manage payment methods.',
  },
};

const ComingSoon = ({ path }) => {
  const navigate = useNavigate();
  const details = featureDetails[path] || { title: 'Feature', description: 'This feature is under development.' };

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-cyan-50">
            <Construction className="h-8 w-8 text-cyan-600" />
          </div>
          <CardTitle className="text-2xl">{details.title}</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <div className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 border border-amber-200 px-3 py-1 text-xs font-medium text-amber-700">
            On the Roadmap
          </div>
          <p className="text-sm text-muted-foreground">
            {details.description}
          </p>
          <p className="text-sm text-muted-foreground">
            We're working hard to bring this feature to you. Stay tuned for updates!
          </p>
          <Button variant="outline" onClick={() => navigate('/dashboard')} className="mt-2">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default ComingSoon;
